import React from 'react';

import { Typography } from '@material-ui/core';

import { ITextWrapperProps } from '../ITextStyleProps';

import useStyles from './styles';

const H6Text = (props: ITextWrapperProps) => {
  const { className, children, color, fontWeight, isLight, noWrap, text } = props;

  const c = useStyles({ fontWeight, color, isLight, noWrap });

  return <Typography className={className ? `${className} ${c.h6Text}` : c.h6Text}>{children || text}</Typography>;
};

export default H6Text;
